import { DateInput, type DateInputProps } from '@mantine/dates';
import { dateInputValueToDateOnly, parseDateOnlyLocal } from '../lib/dateHelpers';

export type UnifyDateInputProps = Omit<DateInputProps, 'value' | 'onChange' | 'defaultValue'> & {
  /** Stored calendar date as YYYY-MM-DD (FHIR valueDate). */
  value?: string | null;
  onChange?: (value: string | null) => void;
};

/**
 * DateInput wrapper that preserves the selected calendar day in local time.
 * Use for FHIR valueDate fields and anywhere YYYY-MM-DD is stored.
 */
export function UnifyDateInput({ value, onChange, ...rest }: UnifyDateInputProps): JSX.Element {
  return (
    <DateInput
      {...rest}
      value={value ? parseDateOnlyLocal(value) : null}
      onChange={(next) => onChange?.(next ? dateInputValueToDateOnly(next) : null)}
    />
  );
}
